import { render } from "./ChannelPage.vue?vue&type=template&id=1b1c0ac8"
import script from "./ChannelPage.vue?vue&type=script&lang=js"
export * from "./ChannelPage.vue?vue&type=script&lang=js"

import "./ChannelPage.vue?vue&type=style&index=0&id=1b1c0ac8&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__